import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LocalStorageService } from '../Service/LocalStorageService';
import { useAppSelector } from '../store/hooks';

const PrivateRoutes = () => {
  const token = LocalStorageService.getItem('accessToken');
  const authUser = useAppSelector(state => state.user?.user);
  const client = useAppSelector(state => state.user?.client);
  const location = useLocation();

  const navigate = useNavigate();
  useEffect(() => {
    const adminRoles = ['admin', 'manager'];
    const isAdmin = adminRoles.includes(authUser?.role || '');

    if (token && (!!client || !isAdmin)) {
      if (location.pathname === '/') {
        navigate('/home');
      }
    } else if (token && isAdmin) {
      navigate('/admin');
    }
  }, [token, authUser]);

  return token ? <Outlet /> : <Navigate to={'/'} />;
};

export default PrivateRoutes;
